<template>
        <div class="warehouses-row">
                <template>
                  <div class="first-row">
                    <b-form-checkbox
                        v-for="option in select.slice(0, Math.ceil(select.length/2))"
                        v-model="option.value"
                    >
                      {{ option.name }}
                  </b-form-checkbox>
                  </div>
                </template>
               <template>
                 <div class="first-row">
                   <b-form-checkbox
                      v-for="option in select.slice(Math.ceil(select.length/2), select.length)"
                      v-model="option.value"
                   >
                   {{ option.name }}
                 </b-form-checkbox>
                 </div>
                </template>
        </div>
</template>

<script>
export default {
  name: 'warehouse',
  props: [
    'select'
  ]
}
</script>
